import { MessageSquare, Compass, BookCheck, Rocket } from "lucide-react";

const steps = [
  {
    number: "01",
    icon: MessageSquare,
    title: "Cuéntanos qué necesitas",
    description:
      "Completa el formulario o escríbenos por WhatsApp. Indícanos tu ramo, tu universidad y en qué punto estás.",
  },
  {
    number: "02",
    icon: Compass,
    title: "Te orientamos",
    description:
      "Evaluamos tu situación y te recomendamos la mejor modalidad: clases particulares, curso asincrónico o una combinación.",
  },
  {
    number: "03",
    icon: BookCheck,
    title: "Accedes al material",
    description:
      "Comienzas tus clases o tu curso con material claro, recursos visuales y seguimiento personalizado.",
  },
  {
    number: "04",
    icon: Rocket,
    title: "Rindes mejor",
    description:
      "Entiendes los conceptos, resuelves ejercicios con más seguridad y enfrentas tus evaluaciones preparado.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="como-funciona"
      data-testid="how-it-works"
      className="py-20 lg:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        {/* Section header */}
        <div className="max-w-2xl mb-16">
          <p className="text-sm uppercase tracking-[0.2em] text-[#c77dff] font-semibold mb-4">
            Proceso simple
          </p>
          <h2
            data-testid="how-it-works-title"
            className="text-2xl md:text-3xl lg:text-4xl font-medium tracking-tight text-white mb-4"
          >
            Cómo funciona
          </h2>
          <p className="text-base text-[#a1a1aa] leading-relaxed">
            Desde el primer contacto hasta tu mejora académica, en cuatro pasos
            claros.
          </p>
        </div>

        {/* Steps */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 lg:gap-8">
          {steps.map((step) => {
            const Icon = step.icon;
            return (
              <div
                key={step.number}
                data-testid={`step-${step.number}`}
                className="relative"
              >
                <span className="text-5xl font-bold text-white/[0.04] absolute -top-2 -left-1 select-none pointer-events-none">
                  {step.number}
                </span>
                <div className="relative pt-8">
                  <div className="p-2.5 rounded-lg bg-[#9d4edd]/10 text-[#c77dff] w-fit mb-5">
                    <Icon size={20} />
                  </div>
                  <h3 className="text-lg font-medium text-white mb-3">
                    {step.title}
                  </h3>
                  <p className="text-sm text-[#a1a1aa] leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
